import type { NearbyLocation } from '~/components/general/nearby-locations/types'
import { ROUTE_BASE_NAME } from '~/constants'

export default function useSuggestedLocations(limit: number) {
  const { locale } = useI18n({ useScope: 'global' })
  const localePath = useLocalePath()

  const { data: rankedCities } = useFetch('/api/popular-cities', {
    key: `popular-cities-${limit}`,
    query: { limit },
  })

  const suggestedLocations = computed<NearbyLocation[]>(() => {
    if (!rankedCities.value?.length) {
      return []
    }

    return rankedCities.value
      .slice(0, limit)
      .map((city) => {
        const destinationPath = locale.value === 'fr' ? city.destinationPathFr : city.destinationPathEn

        return {
          ...city,
          path: localePath({
            name: ROUTE_BASE_NAME.rv_rentals_destination,
            params: {
              destinationPath: destinationPathSegments(destinationPath),
            },
          }),
          distanceKm: null,
        }
      })
  })

  return { suggestedLocations }
}
